const formatPhoneNumber = (phoneNumber) => {
  const phoneNumberDigits = phoneNumber.replace(/\D/g, "");

  let formattedPhoneNumber = "";
  if (phoneNumberDigits.length > 0) {
    formattedPhoneNumber += `(${phoneNumberDigits.slice(0, 3)}`;
  }
  if (phoneNumberDigits.length > 3) {
    formattedPhoneNumber += `) ${phoneNumberDigits.slice(3, 6)}`;
  }
  if (phoneNumberDigits.length > 6) {
    formattedPhoneNumber += `-${phoneNumberDigits.slice(6, 10)}`;
  }

  return formattedPhoneNumber;
};
export default formatPhoneNumber;
